import { render, staticRenderFns } from "./topic-journey-panel.vue?vue&type=template&id=52724ccc&scoped=true"
import script from "./topic-journey-panel.ts?vue&type=script&lang=ts&external"
export * from "./topic-journey-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./topic-journey-panel.scss?vue&type=style&index=0&id=52724ccc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52724ccc",
  null
  
)

export default component.exports